import jwtdecode from 'vue-jwt-decode';
import { oAuth, Auth } from './classes/Auth';


export const getTokenPayload = (token?: string) => {
    if(!token){
        return jwtdecode.decode(oAuth.getToken());
    }
    return jwtdecode.decode(token);
}

export function getImage(path = null, auth_project = false){
    const auth = new Auth;
    if(path){
        return `${process.env.VUE_APP_BACKEND}/avatars/${path}`;
    }else if(auth.getProject() && auth_project){
        return `${process.env.VUE_APP_BACKEND}/avatars/${auth.getProject().image}`;
    }
    //return `${process.env.VUE_APP_BACKEND}/nofoto.png`;
    return ""
}